import template from './external_appointment_cancel.html';

angular.module('bb.external').component('bbExternalAppointmentCancel', {
  bindings: {
    appointment: '<',
    newStatus: '<',
    isNewAppointment: '<',
    clearSelected: '<',
    serverDate: '<',
  },
  controller: ExternalAppointmentCancelController,
  controllerAs: 'vm',
  template,
});

ExternalAppointmentCancelController.$inject = [
  '$window',
  '$routeParams',
  'ExternalService',
  'ExternalAuth',
];

function ExternalAppointmentCancelController(
  $window,
  $routeParams,
  ExternalService,
  ExternalAuth,
) {
  const vm = this;
  vm.auth = ExternalAuth.auth;
  vm.$onInit = () => {
    vm.toggleLoading();
    vm.appointment = {
      id: $routeParams.appointmentId || '',
    };

    if ($routeParams.appointmentId) {
      ExternalService.getAppointment(
        $routeParams.dashboardId,
        $routeParams.appointmentId,
      )
        .then(appointment => {
          vm.appointment = appointment;
        })
        .catch(err => {
          ErrorService.toastyHTTPErr(err);
        })
        .finally(() => {
          vm.appointmentsLoaded = true;
        });
    }
  };

  vm.toggleLoading = () => {
    vm.externalStatusChangeLoading = !vm.externalStatusChangeLoading;
  };

  vm.dataLoading = () =>
    vm.externalStatusChangeLoading && !vm.appointmentsLoaded;
}
